import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { BenefitsCardPlan } from '@/models/benefits_cards/benefits_card_plan_model';
import { ReqBenCardsRenewScreens, useReqRenewBenefitsCardPlansStore } from '@/stores/benefits_card_plans/request_renew_benefits_cards_plan_store';
import PatchBenCardsPlanScreen from './screens/PatchBenCardsPlanScreen.vue';
import ConfirmValueScreen from './screens/ConfirmValueScreen.vue';
import CommonModal from '../CommonModal.vue';
import PaymentScreen from './screens/PaymentScreen.vue';
import { MinimizedType } from '@/stores/minimized_modal_store/minimized_modal_store';


export default /*@__PURE__*/_defineComponent({
  __name: 'RequestRenewBenefitsCardsPlan',
  setup(__props, { expose: __expose }) {

const commonModal = ref<InstanceType<typeof CommonModal>>();
const reqRenewBenCardsPlanStore = useReqRenewBenefitsCardPlansStore;

__expose({
  open: async (params: {
    zIndex?: number;
    benefitsCardsPlan: BenefitsCardPlan;
  }) => {
    if (reqRenewBenCardsPlanStore.benefitsCardsPlan?.getId() != params.benefitsCardsPlan.getId()) {
      reqRenewBenCardsPlanStore.$reset();
    }
    reqRenewBenCardsPlanStore.setBenefitPlan(params.benefitsCardsPlan);
    return await commonModal.value?.open({
      zIndex: params.zIndex ?? 50,
      name: `Renovação ${params.benefitsCardsPlan?.getPlanName()}`,
    });
  },
  close: () => {
    commonModal.value?.close();
  },
});


const __returned__ = { commonModal, reqRenewBenCardsPlanStore, get ReqBenCardsRenewScreens() { return ReqBenCardsRenewScreens }, PatchBenCardsPlanScreen, ConfirmValueScreen, CommonModal, PaymentScreen, get MinimizedType() { return MinimizedType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})